import { useEffect, useRef, useState } from "react";
import Cookies from "js-cookie";
import Swal from "sweetalert2";
import { calculateTimeLeft, formatTime } from "./TimeUtility";
export default function SessionTimer({ onLogout, onProgress }) {
    const refreshExpiry = Number(Cookies?.get("refreshTokenTime"));
    const [timeLeft, setTimeLeft] = useState("--:--");
    const [progress, setProgress] = useState(100);
    const timerRef = useRef(null);
    const alertShownRef = useRef(false);
    const initialDuration = refreshExpiry ? refreshExpiry - Date.now() : 0;

    useEffect(() => {
        startTimer();
        return () => clearInterval(timerRef.current);
        // eslint-disable-next-line
    }, [refreshExpiry]);

    const startTimer = () => {
        if (!refreshExpiry) return;

        const updateTimer = () => {
            const remaining = calculateTimeLeft(refreshExpiry);
            setTimeLeft(formatTime(remaining));

            const newProgress =
                initialDuration > 0
                    ? Math.max(0, (remaining / initialDuration) * 100)
                    : 0;

            setProgress(newProgress);

            // ✅ ONLY ADD THIS LINE
            if (onProgress) onProgress(newProgress);

            if (remaining <= 0 && !alertShownRef.current) {
                alertShownRef.current = true;
                clearInterval(timerRef.current);

                Swal.fire({
                    title: "Session Expired",
                    text: "Please login again",
                    icon: "warning",
                    confirmButtonText: "OK",
                    allowOutsideClick: false,
                }).then(() => onLogout());
            }
        };

        updateTimer();
        timerRef.current = setInterval(updateTimer, 1000);
    };

    return (
        <div className="session-timer-container">
            <div className="timer-box">
                <span className="timer-text">{timeLeft}</span>
            </div>


        </div>
    );
}



